export const toTrainingSavePlanInput = (rpcParams: {
  workouts?: unknown;
  deleted_workouts?: string[];
  planname?: string;
  p_client_id?: string | null;
  planid?: string | null;
  is_primary?: boolean;
  is_visible?: boolean;
  p_is_template?: boolean;
  p_scheduling_mode?: string;
  p_schedule_entries?: unknown;
  p_fixed_schedule_entries?: unknown;
}) => ({
  workouts: rpcParams.workouts ?? [],
  deletedWorkouts: rpcParams.deleted_workouts ?? [],
  planName: rpcParams.planname ?? "",
  clientId: rpcParams.p_client_id ?? null,
  planId: rpcParams.planid ?? null,
  isPrimary: rpcParams.is_primary,
  isVisible: rpcParams.is_visible,
  isTemplate: rpcParams.p_is_template,
  schedulingMode: rpcParams.p_scheduling_mode,
  scheduleEntries: rpcParams.p_schedule_entries ?? [],
  fixedScheduleEntries: rpcParams.p_fixed_schedule_entries ?? [],
});
